// extracted by mini-css-extract-plugin
module.exports = {"tabbedNav":"DocumentNotices_tabbedNav__3g9TP","selected":"DocumentNotices_selected__2Mh-_","inputs":"DocumentNotices_inputs__2w00L"};